const getApiBaseUrl = () => {
  if (process.env.NODE_ENV === "production") {
    return process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL}/api`
      : "/api";
  }
  // Development: always use proxy (relative path avoids CORS)
  return "/api";
};

export const config = {
  apiBaseUrl: getApiBaseUrl(),
};
